_getEventDetails